import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { SystemExportDepartmentFilesPathParameters } from 'api/actions/system-export-department-files/system-export-department-files-path-parameters';
import { SystemExportDepartmentFilesResponse } from 'api/actions/system-export-department-files/system-export-department-files-response';

type SystemExportDepartmentFilesQueryParameters = Record<string, any>;

/**
 * The path of the SystemExportDepartmentFiles action.
 */
export const systemExportDepartmentFilesActionPath = new SweetPath<keyof SystemExportDepartmentFilesPathParameters>(
  '/api/system/export/department-files/{organizationId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized SystemExportDepartmentFiles actions.
 */
export default function createSystemExportDepartmentFilesAction(axios: AxiosInstance) {
  return function systemExportDepartmentFilesAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: SystemExportDepartmentFilesPathParameters;
    query?: SystemExportDepartmentFilesQueryParameters;
  }) {
    const path = systemExportDepartmentFilesActionPath.insert(parameters);

    return axios.request<SystemExportDepartmentFilesResponse, SystemExportDepartmentFilesResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
